<template>
   <b-row class="payment-step">
    <b-col cols="12">
      <div class="modal-block-title">Enter your {{ this.orderData.asset.name }} wallet ID</div>
    </b-col>
    <b-col cols="12">
      <e-input type="text" floating label="Wallet" v-model="wallet"></e-input>

      <e-hint title="Notice">We will send you the coins to the address you enter here. Make sure you enter a VALID Bitcoin wallet or your coins may be lost. You will need to reconfirm your Wallet ID later.</e-hint>

      <e-button :disabled="isWalidAddress" @click="nextPage" style="margin-top: 20px; margin-left: auto;">Use this Wallet ID</e-button>
    </b-col>
  </b-row>
</template>

<script>
import { mapGetters, mapActions, mapState, mapMutations } from "vuex";
export default {
  name: "step-wallet",
  components: { },
  data() {
    return {
      wallet: null,
    };
  },
  methods: {
     ...mapActions("settings", ["setPaymentState"]),
     ...mapMutations("orders", ["setWalletId"]),
    nextPage() {
      this.setWalletId(this.wallet);
      this.$emit('nextPage');
    }
  },
   computed: {
    ...mapGetters("orders", {
      orderData: 'buyModalData'
    }),
    isWalidAddress() {
      return !(this.wallet !== null && this.wallet !== '');
    },
    total() {
      return (this.orderData.amount / this.orderData.asset.price.value).toFixed(6);
    }
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/modals/buyCrypto/stepWallet.vue